import {
  FETCH_DELETE_ROLE_BY_ID_REQUEST,
  FETCH_DELETE_ROLE_BY_ID_SUCCESS,
  FETCH_DELETE_ROLE_BY_ID_FALUIRE,
} from './deleteRoleByIDTypes'

const initialState = {
  loading: false,
  deleteRolesInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_DELETE_ROLE_BY_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DELETE_ROLE_BY_ID_SUCCESS : return {
      ...state,
      deleteRolesInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DELETE_ROLE_BY_ID_FALUIRE : return {
      ...state,
      loading: false,
      deleteRolesInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
